import { MESES } from '../../config/aniomeses'
import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
class Calidad {
  getTotalMercaderiaSinAnalisis (anio, mes) {
    const axios = getAxiosInstance()

    const mesNumero = MESES.indexOf(mes) + 1

    const parametros = {
      parametros: {
        anio_descarga: anio,
        mes_descarga: mesNumero
      }
    }
    const filtro = JSON.stringify(parametros)
    const promise = axios.get(`reporte_total_carga_entrante_sin_analisis?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getMercaderiaSinAnalisis (anio, mes) {
    const axios = getAxiosInstance()

    const mesNumero = MESES.indexOf(mes) + 1
    const clave = {
      clave: {
        anio_descarga: anio,
        mes_descarga: mesNumero
      }
    }
    const filtro = JSON.stringify(clave)
    const promise = axios.get(`consulta_carga_entrante_sin_analisis_por_fecha?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getDatosSolicituAnalisis (fechaDesde, fechaHasta, formValues) {
    const axios = getAxiosInstance()
    const clave = {
      clave: {
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        cereal: formValues.cereal,
        exportador: formValues.exportador,
        titular_de_cupo: formValues.titularDeCupo,
        corredor: formValues.corredor,
        carta_de_porte: formValues.numero
      }
    }
    const filtro = JSON.stringify(clave)
    const promise = axios.get(`?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  generarSolicituAnalisis () {

  }

  getCalidadMercaderiaEmbarcada (fechaDesde, fechaHasta, cereal = null, exportador = null) {
    const axios = getAxiosInstance()
    const clave = {
      clave: {
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        cereal: cereal,
        exportador: exportador
      }
    }
    const filtro = JSON.stringify(clave)
    const promise = axios.get(`consulta_calidad_mercaderia_embarcada_filtrada?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getCalidadMercaderiaEmbarcadaTotal (fechaDesde, fechaHasta, cereal = null, exportador = null) {
    const axios = getAxiosInstance()
    const parametros = {
      parametros: {
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        cereal: cereal,
        exportador: exportador
      }
    }
    const filtro = JSON.stringify(parametros)
    const promise = axios.get(`reporte_calidad_mercaderia_embarcada?r=${filtro}`)

    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getControldeGrado (fechaDesde, fechaHasta) {
    const axios = getAxiosInstance()
    const clave = {
      clave: {
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta
      }
    }
    const filtro = JSON.stringify(clave)
    const promise = axios.get(`consulta_compara_grado_por_fecha?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  getControlDeRebajasPorFecha (fechaDesde, fechaHasta) {
    const axios = getAxiosInstance()
    const clave = {
      clave: {
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta
      }
    }
    const filtro = JSON.stringify(clave)
    const promise = axios.get(`consulta_compara_rebajas_fuera_de_grado_por_fecha?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }
}

export default Calidad
